import React from 'react';

export const AssignedPanelbarTitle = (props) => {
    const {
        text,
    } = props;
    return (
        <>
            {text?.length <= 100 ? (
                <div
                    className={"k-h5"}
                    style={{
                        color: 'white',
                        margin: '0 0 0 2px',
                        wordBreak: 'break-all',
                        overflowWrap: 'anywhere',
                    }}
                >
                    {text}
                </div>
            ) : (
                <div
                    className={"k-h5"}
                    style={{
                        color: 'white',
                        margin: '0 0 0 2px',
                        wordBreak: 'break-all',
                        overflowWrap: 'anywhere',
                        lineHeight: '1rem',
                        fontSize: '1rem',
                    }}
                >
                    {text}
                </div>
            )}
        </>
    )
}